import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { log } from 'console';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
  selector: 'app-gambling-problem',
  templateUrl: './gambling-problem.component.html',
  styleUrls: ['./gambling-problem.component.scss'],
})
export class GamblingProblemComponent implements OnInit {

  public responsibleGamingNumber: string;
  public labels: SiteContentInterface;
  constructor(private config: ConfigService,
    private siteContentService:SiteContentService,
    private cgd:ChangeDetectorRef) {
      
    this.labels = new SiteContentModel();
    this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER;
  }

  ngAfterViewInit(){
    this.siteContentService.loadConfig('gambling_problem')
    .then((response: SiteContentInterface) => {
      this.labels = response;
      this.cgd.detectChanges();
    })
}

  ngOnInit() {}

}
